import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BASIC_MAIL_VALIDATOR } from '../../shared/newsletter';
import axios from 'axios';

import '../../../packs/translations';
I18n.locale = $('html').attr('lang');

const SendTerm = (props) => {
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [content, setContent] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const email_input = props.sendToClient ? "client_email" : "friend_email";
  const content_input = props.sendToClient ? "client_content" : "friend_content";
  const icon = props.sendToClient ? "fas fa-envelope" : "far fa-envelope";

  const handleSubmit = (event) => {
    const url = props.sendToClient ? `/admin/send_to_client/${props.term_id}` : `/send_to_friend/${props.term_id}`
    event.preventDefault();
    axios.get(url, {
      params: {
        email: email,
        content: content,
        term_id: props.term_id,
        price: props.price,
        link: props.link,
        config: props.config
      }
    }).then(response => {
      setEmail('');
      setContent('');
      setResponseMessage(I18n.t('js.send_to.success'));
    }).catch(error => {
      console.log(error.response);
    })
  }

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    const value = email;
    value.length > 0 && !BASIC_MAIL_VALIDATOR.test(value) ? setResponseMessage(I18n.t("js.email_info")) : setResponseMessage('');
  }

  return (
    <div className={visible ? 'send-box sidebar-box' : ''}>
      <h4 className="pointer-cursor" onClick={() => setVisible(!visible)}>
        <i className={icon+" mr-2"} />
        { props.sendToClient ? I18n.t("js.send_to.client") : I18n.t("js.send_to.friend") }
      </h4>
      {visible &&
        <React.Fragment>
          <div className="row">
            <div className="col-12">
              <input
                type="email"
                className="form-control"
                name={email_input}
                id={email_input}
                value={email}
                onChange={handleEmailChange}
                placeholder={props.sendToClient ? I18n.t("js.send_to.client_email") : I18n.t("js.send_to.friend_email")}
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-md-12">
              <textarea
                type="text"
                name={content_input}
                id={content_input}
                className="form-control"
                placeholder={I18n.t("js.send_to.content_placeholder")}
                value={content}
                onChange={(e) => {setContent(e.target.value); setResponseMessage('');}}
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-md-6">
              <button
                id="send"
                type= "button"
                disabled={email && BASIC_MAIL_VALIDATOR.test(email) ? false : true}
                onClick={handleSubmit}
                className="btn btn-primary">
                <i className="fas fa-envelope"></i>
                {I18n.t('js.send_to.send')}
              </button>
            </div>
            <div className="col-md-6 text-tertiary">
              {responseMessage}
            </div>
          </div>
        </React.Fragment>
      }
    </div>
  );
}

SendTerm.propTypes = {
  sendTo: PropTypes.bool,
  term_id: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  link: PropTypes.string.isRequired,
  config: PropTypes.string
}

SendTerm.defaultProps = {
  sendToClient: false,
  config: ''
}

export default SendTerm;
